import React from 'react';
import { useChatbot } from '../../context/chatbot-provider';
import { useAuth } from '../../context/auth-provider';
import { FaRobot, FaTimes } from 'react-icons/fa';

const ChatbotButton = () => {
  const { isOpen, toggleChatbot } = useChatbot();
  const { isLoggedIn } = useAuth();

  // Only show the chatbot button when user is logged in
  if (!isLoggedIn) {
    return null;
  }

  return (
    <button
      onClick={toggleChatbot}
      className={`
        fixed bottom-6 right-6 z-50 
        w-14 h-14 rounded-full 
        flex items-center justify-center
        shadow-lg transition-all duration-300 ease-in-out
        hover:scale-110 hover:shadow-xl
        chatbot-button
        ${isOpen 
          ? 'bg-red-500 hover:bg-red-600' 
          : 'bg-yellow-500 hover:bg-yellow-600'
        }
      `}
      aria-label={isOpen ? 'Close chatbot' : 'Open chatbot'}
    >
      {isOpen ? (
        <FaTimes className="text-white text-xl" />
      ) : (
        <FaRobot className="text-black border-2 border-black rounded-full p-3" style={{fontSize: '50px'}} />
      )}
    </button>
  );
};

export default ChatbotButton;
